import { action } from 'satcheljs';

export const addToNewReminderIdMap = action('addToNewReminderIdMap', (id: string) => ({
    id,
}));

export const removeFromNewReminderIdMap = action('removeFromNewReminderIdMap', (id: string) => ({
    id,
}));

export const resetNewReminderIdMap = action('resetNewReminderIdMap');
